export default "__VITE_ASSET__KnD4TSEc__"